import React, { useCallback, useEffect, useState } from 'react';
import api from '../api';

const types = { Document_Ignore: 'Игнор', Document_Revoke: 'Отзыв согласия', Document_Accept: 'Акцепт', Document_Autoaccept: 'Автоакцепт', Document_Notification: 'Уведомление' };
const delivery = { Queued: 'В очереди', SmtpAccepted: 'Принято SMTP', RetryScheduled: 'Повтор запланирован', Failed: 'Ошибка отправки', Skipped: 'Пропущено' };

export default function AgreementEvents({ documentId, accountId }) {
    const [events, setEvents] = useState([]);
    const [cursor, setCursor] = useState(null);
    const [more, setMore] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const load = useCallback((after) => {
        setLoading(true); setError('');
        return api.get('/api/admin/agreements/events', { params: { documentId, accountId, limit: 50, ...after } })
            .then(({ data }) => {
                setEvents(previous => after ? [...previous, ...data] : data);
                setMore(data.length === 50);
                const last = data[data.length - 1];
                setCursor(last ? { before: last.timestamp, beforeId: last.id } : null);
            }).catch(() => setError('Не удалось загрузить журнал'))
            .finally(() => setLoading(false));
    }, [documentId, accountId]);
    useEffect(() => { load(null); }, [load]);
    return <section className="space-y-3 text-left">
        <div className="flex items-center justify-between gap-3">
            <h3 className="font-semibold text-gray-900">Журнал событий</h3>
            <button type="button" className="text-sm text-blue-600" disabled={loading} onClick={() => load(null)}>Обновить</button>
        </div>
        <p className="text-xs text-gray-500">Время в UTC. «Принято SMTP» означает принятие почтовым сервером, доставка в ящик не подтверждена.</p>
        {error && <p role="alert" className="text-red-600">{error}</p>}
        {!events.length && !loading && !error && <p className="text-sm text-gray-500">Событий пока нет.</p>}
        <div className="space-y-2">
            {events.map(event => <details key={event.id} className="border border-gray-200 rounded-lg p-3 text-sm">
                <summary className="cursor-pointer text-gray-900 break-words">
                    {types[event.type] || event.type} · {event.document_id} v{event.version} · аккаунт {event.account_id}
                    {event.metadata?.delivery_status && ` · ${delivery[event.metadata.delivery_status] || event.metadata.delivery_status}`}
                    <span className="block text-xs text-gray-500 mt-1">{event.timestamp}</span>
                </summary>
                <dl className="mt-3 space-y-2 text-gray-600 break-all">
                    <div><dt className="font-medium">UUID</dt><dd>{event.id}</dd></div>
                    <div><dt className="font-medium">IP / UserAgent</dt><dd>{event.ip_address || '—'} · {event.useragent || '—'}</dd></div>
                    <div><dt className="font-medium">Ссылка</dt><dd><a className="text-blue-600" href={event.url} target="_blank" rel="noopener noreferrer">{event.url}</a></dd></div>
                    <div><dt className="font-medium">PDF</dt><dd>{event.doc_url || 'Не был задан в старом consent'}</dd></div>
                    <div><dt className="font-medium">SHA-256</dt><dd className="font-mono text-xs">{event.doc_hash || 'Неизвестен для старой версии'}</dd></div>
                    <div><dt className="font-medium">Metadata</dt><dd><pre className="whitespace-pre-wrap text-xs">{JSON.stringify(event.metadata, null, 2)}</pre></dd></div>
                </dl>
            </details>)}
        </div>
        {more && <button type="button" className="text-blue-600 text-sm" disabled={loading} onClick={() => load(cursor)}>{loading ? 'Загрузка…' : 'Ещё события'}</button>}
    </section>;
}
